
export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/273025989b3af8a7ee2fe9fb5b53dd8c.png"
          alt="현대 건축"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/30"></div>

      <div className="relative h-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-12 flex items-end pb-16 sm:pb-20 lg:pb-24">
        <div className="w-full max-w-3xl">
          <h1 className="text-3xl sm:text-5xl lg:text-7xl font-extrabold text-white leading-tight mb-4 sm:mb-6 lg:mb-8 tracking-tight">
            삶에 영감을 주는<br />공간을 창조합니다
          </h1>
          <p className="text-sm sm:text-base lg:text-xl text-white/90 font-light leading-relaxed mb-8 sm:mb-10 lg:mb-12 max-w-2xl">
            형태, 기능, 그리고 인간의 감성이 조화를 이루는 건축 경험을 디자인하여 일상을 더욱 풍요롭게 만드는 공간을 창조합니다.
          </p>
          <a
            href="#portfolio"
            className="inline-flex items-center space-x-3 sm:space-x-4 px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center">
              <i className="ri-building-2-line text-lg sm:text-xl"></i>
            </div>
            <span className="text-sm sm:text-base tracking-wide">작품 둘러보기</span>
          </a>
        </div>
      </div>
    </section>
  );
}
